import React from "react";
import SharedPieChart from "./SharedPieChart";
import { PieData } from "./TrendStatsCard/NetProfitStatCard";
import { ArrowDown, ArrowUp, CloseIcon } from "../../assets/icons";
import { formatMoney, useGetPaymentCurrencyList } from "../../utils";
import { useCompanyStore } from "../../state/useCompanyStore";
interface Props {
  chartData?: Record<string, PieData> | any;
  handleExpandToggle: () => void;
  isUptrend: boolean;
  value: string | number;
  showArrow?: boolean;
  selectedLabel: string;
  percentageValue?: number;
}
export default function ExpenseModal({
  chartData,
  handleExpandToggle,
  isUptrend,
  value,
  showArrow,
  percentageValue,
  selectedLabel,
}: Props) {
  const companyProfile = useCompanyStore();
  const { userCurrencyCode } = useGetPaymentCurrencyList(
    companyProfile.company,
  );
  return (
    <div className="bg-white rounded-md max-h-[70vh] overflow-auto mt-[4em]">
      <div className="md:p-4 md:px-8 p-3 flex items-center justify-between w-full">
        <div className="p-2 md:p-0">
          <h1 className="text-[#475467] text-[14px]">Expense by Category</h1>
          <h1 className="text-[#1D2939] text-[14px] font-semibold">
            {selectedLabel}
          </h1>
        </div>
        <button type="button" onClick={handleExpandToggle} className="mr-4">
          <CloseIcon />
        </button>
      </div>
      <hr />
      <div className="md:p-4 md:px-8 p-3">
        <div className="md:flex items-center">
          <div className="flex items-center gap-2 md:mt-5">
            <p className="text-[20px] 1220:text-[16px] xl:text-[20px] md:mb-3 text-[#000000] font-semibold leading-6">
              {Number(value) == 0
                ? "--"
                : formatMoney(Number(value), userCurrencyCode?.currency)}
            </p>
          </div>
          <div className="flex items-center justify-between gap-1 md:mt-1">
            <p className="text-[20px] 1220:text-[16px] xl:text-[20px] text-[#000000] font-semibold leading-6">
              {Number(value) !== 0 && showArrow && (
                <div className="flex items-center gap-1">
                  <div
                    className={` p-1 flex rounded-[4px] gap-1 items-center ${
                      isUptrend ? "" : ""
                    }`}
                  >
                    {isUptrend ? <ArrowUp /> : <ArrowDown />}
                    <h1
                      className={`text-[14px] font-semibold 1220:text-[16px] xl:text-[16px] ${isUptrend ? "text-[#37C89A]" : "text-[#D82020]"}`}
                    >
                      {percentageValue}%
                    </h1>
                  </div>
                  <span className="text-[#475467] text-[14px] font-semibold">
                    vs last period
                  </span>
                </div>
              )}
            </p>
          </div>
        </div>
        <div className="flex mx-10">
          <SharedPieChart data={chartData} baseColor="#F79009" expand={true} />
        </div>
      </div>
    </div>
  );
}
